import {
  SPLUNK_RUM_FIELDS,
  SplunkRumFields,
  SplunkRumWorkflows,
} from '@/constants/splunk'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export type RumEventAttrs = Partial<
  Record<SplunkRumFields[keyof SplunkRumFields], string> &
    Record<
      typeof SPLUNK_RUM_FIELDS.WORKFLOW,
      SplunkRumWorkflows[keyof SplunkRumWorkflows]
    >
>

export function publishRumEvent(
  attributes: RumEventAttrs &
    Record<
      typeof SPLUNK_RUM_FIELDS.WORKFLOW,
      SplunkRumWorkflows[keyof SplunkRumWorkflows]
    >,
) {
  const northboundAPIs = getCommonsNorthboundAPIs()
  try {
    northboundAPIs.v1.monitoring
      .startSpan(
        northboundAPIs.v1.store.state.onboarding.sessionContext
          .currentServiceId,
        attributes,
      )
      .end()
  } catch (error) {
    OobeLogger.error(
      'Not able to start span through Shell.v1.monitoring',
      error,
    )
  }
}
